<template>
  <el-dialog
    :visible="visible"
    width="600px"
    @close="closeFn"
    title="添加增远程升级文件"
    >

    <div class="form">
      <el-row class="flex">
        <el-col :span="3">版本备注：</el-col>
        <el-col :span="20">
          <el-input v-model="version" />
        </el-col>
        <el-col :span="3">文件：</el-col>
        <el-col :span="20">
          <el-upload
            class="up__btn"
            action=""
            :http-request="({ file }) => (excelFile = file)"
            :show-file-list="false"
            drag
          >
            <div v-if="!excelFile">
              <i class="el-icon-upload"></i>
              <div class="el-upload__tip" slot="tip">只能上传文件，且不超过500kb</div>
            </div>
            <div v-else>
              <i class="el-icon-upload"></i>
              <div class="label">{{ excelFile.name }}</div>
            </div>
          </el-upload>
        </el-col>
      </el-row>

    </div>
    <div class="footer">
      <el-button @click="closeFn">取 消</el-button>
      <el-button @click="onConfirm" type="primary">上 传</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name:'FileForm',
  props:{
    visible:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return {
      loading:false,
      excelFile:null,
      version:'',
    }
  },
  methods:{
    //关闭弹框
    closeFn(){
      this.version = '';
      this.excelFile = null;
      this.$emit('update:visible',false);
    },

    //上传文件
    async onConfirm(){
      let formData = new FormData();
      formData.append('file',this.excelFile);
      formData.append('version',this.version);
      try{
        const { code, msg } = await this.$API.addUpgradeFiles(formData);
        if(code !== 0) throw { msg };
        this.$msg({
          type:'success',
          message:msg,
        });
        this.$emit('update:visible',false);
        this.$emit('onSuccess');
      }catch({ msg }){
        this.$msg({
          type:'error',
          message:msg,
        });
      }
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header{
  border-bottom: 1px solid #eee;
}
::v-deep .el-dialog__body{
  padding-bottom: 0;
}
.form{
  padding-bottom: 40px;
  .flex{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .up__btn{
    text-align: center;
    .label{
      margin-top: 20px;
    }
    .el-icon-upload{
      font-size: 60px;
    }
    .el-upload:active{
      color:#FFF;
    }
  }
  ::v-deep .el-upload{
    margin-top: 10px;
    width: 100%;
    .el-upload-dragger{
      width: 100%;
    }
  }
  .up__btn .el-upload__text{
    width: 120px;
  }
}
.footer{
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
  border-top: 1px solid #eee;
}

</style>
